import { colors } from '@mui/material';
import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	iconCell: {
		width: 73,
	},
	tipCard: {
		backgroundColor: colors.indigo[50],
		boxShadow: 'none',
		padding: '0.333rem',
	},
	cell: {
		display: 'flex',
		alignItems: 'center',
		width: '250px',
		height: '19px',
	},
	cellStyle: {
		width: '8.25rem',
	},
}));
